export default __webpack_public_path__ + "static/media/exploreCup.e6731ade.svg";